export default "__VITE_ASSET__e4f3e395__"